export default __webpack_public_path__ + "static/media/close-modal-dark.2a95e848.svg";